<template>
    <one-column-sidebar-left
        back-button-tab-selector="organizationbackbutton"
        sub-menu-selector="adminpanel"
    >
        <div slot="buttonsRight">
            <Button
                    type="button"
                    class="mb-3 mt-5"
                    :deactivated="!enableSaving"
                    @click="save"
            >
                <icon v-if="enableSaving" type="save"/><icon v-else type="ban" /> {{ $t('SAVE') }}
            </Button>
        </div>
        <div slot="mainContent">
            <h1>{{ $t('createNewOrganization') }}</h1>
            <organization-add-form
                    ref="addOrganizationForm"
                    @enableSaving="doEnableSaving"
            />
        </div>
    </one-column-sidebar-left>
</template>

<script>
    import Button from "../components/forms/Button";
    import OneColumnSidebarLeft from "../layouts/OneColumnSidebarLeft";
    import Icon from "../components/Icon";
    import OrganizationAddForm from "@/components/forms/OrganizationAddForm";
    export default {
        name: "OrganizationAdd",
        components: {
            Button,
            OneColumnSidebarLeft,
            Icon,
            OrganizationAddForm,
        },
        data() {
            return {
                enableSaving: false,
            };
        },
        methods: {
            doEnableSaving: function(bool){
                this.enableSaving = bool;
            },
            save: function() {
              this.$refs.addOrganizationForm.save();
            },
        }
    }
</script>